/**
 * Border Radius Tokens (Internal Design System)
 *
 * Consistent border radius values for UI components.
 */

export const borderRadius = {
  none: '0',
  sm: '0.25rem',
  md: '0.5rem',
  lg: '0.75rem',
  xl: '1rem',
  full: '9999px',
} as const

export type BorderRadius = typeof borderRadius
